import { Model } from './model';
import { Entity } from './entity';
import { Ship } from './ship';
import { Association } from './association';
import { FilterHandler } from 'app/shared/filter-handler';

export class Document extends Model {
  id: number;
  document_file: string;
  document_type: string;
  day: string;
  buyer_entity: Entity;
  ship: Ship;
  association: Association;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new Document(values);
  }
}

export class DocumentFilter extends FilterHandler {
  date = '';
  document_type: String;
  buyer_entity: Entity[] = [];
  ship: Ship[] = [];

  constructor(values: Object = {}) {
    super();
    const today = new Date();
    this.document_type = '';
    this.buyer_entity = [];
    this.ship = [];
    this.date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/document.ts